import React, { useState, useEffect, useReducer } from "react";
import { connect } from "react-redux";

import {
  Button,
  ColumnLayout,
  FormField,
  Input,
  Select,
  Autosuggest,
  Spinner
} from "AWS-UI-Components-React";

import {
  asyncFetchTestCases
} from "../actions/testCaseActions.js";

import TestCaseTable from "./TestCaseTable.jsx";

function Dashboard(props) {

  const { resultsLoading } = props.testCaseState;

  const [testName, settestName] = useState("");
  const [testSuite, settestSuite] = useState("");
  const [versionId, setversionId] = useState("");

  const [testBody, settestBody] = useState("");
  
  const [feature, setFeature] = useState("");
  const [userStory, setUserStory] = useState("");
  const [tags, setTags] = useState("");

  const [selectValues, setSelectValues] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      readinessState: null,
      automationState: null
    }
  );

  const handleSelectChange = (e) => {
    const { name, value } = e.detail.selectedOption;
    setSelectValues({ [name]: value });
  };

  const handleClearQueryInputs = () => {
    setSelectValues({
      readinessState: null,
      automationState: null
    });
    setUserStory("");
    setFeature("");
    setTags("");
    settestName("");
    settestSuite("");
    setversionId("");
  };

  const handleFetchTestCases = () => {
    props.fetchTestCases(
      testName,
      testSuite,
      versionId
    );
  };

  return (
    <div >
      <h1 className="awsui-text-large">
        Search Test Cases
      </h1>
      <div className="awsui-util-container">
        <ColumnLayout columns={3} variant="text-grid">
          <div data-awsui-column-layout-root="true">
            <div className="awsui-util-d-ib">
              <FormField label="Test Suite">
                <Input
                  type="text"
                  name="testSuite"
                  placeholder="Enter Test Suite"
                  value={testSuite}
                  onInput={(e) => settestSuite(e.detail.value)}
                />
              </FormField>
            </div>
            <div className="awsui-util-d-ib">
              <FormField label="Test Name">
                <Input
                  type="text"
                  name="testName"
                  placeholder="Enter Test Name"
                  value={testName}
                  onInput={(e) => settestName(e.detail.value)}
                />
              </FormField>
            </div>
            <div className="awsui-util-d-ib">
              <FormField label="Version id">
                <Input
                  type="text"
                  name="versionId"
                  placeholder="Enter Version id"
                  value={versionId}
                  onInput={(e) => setversionId(e.detail.value)}
                />
              </FormField>
            </div>
          </div>        

        </ColumnLayout>
        <div className="awsui-util-action-stripe-group">
          <Button
            text="Search Test Cases"
            onClick={handleFetchTestCases}
            disabled={!testName || !testSuite}
            variant="primary"
            loading={resultsLoading}
          />

          <Button
            text="Clear"
            loading={resultsLoading}
            onClick={handleClearQueryInputs}
          />
        </div>
      </div>
      <div>
        <TestCaseTable />
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  testCaseState: state.testCaseState,
  featureState: state.featureState,
  userStoryState: state.userStoryState,
  tagState: state.tagState
});

const mapDispatchToProps = dispatch => ({
  fetchTestCases: (
    testName,
    testSuite,
    versionId
  ) => dispatch(asyncFetchTestCases(
    testName,
    testSuite,
    versionId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard.jsx